import CategoriesClasses from '../CategoriesApp/CategoriesApp.scss';
import React from 'react';

export const Hero = () => {
  return <div className={CategoriesClasses.hero}>Hero</div>;
};
